import { Button, Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const CustomDefaultButton = ({ title = "", onClick }) => {
  return (
    <Button
      style={{
        backgroundColor: "transparent",
        height: 43,
        borderRadius: 5,
        minWidth: 160,
        color: "#393B4A",
        fontSize: 16,
        fontFamily: "Poppins-Medium",
        border: "0.5px solid #393B4A",
      }}
      onClick={onClick}
    >
      {title}
    </Button>
  );
};

export default CustomDefaultButton;
